import { useState } from "react";
import React from "react";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import toast from "react-hot-toast";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { red } from "@mui/material/colors";

import { register, sendOTP, verifyOTP } from "../services/authService";
import Loading from "../components/Loading";
//import { useEffect } from "react";

const Register = () => {
  const [passwordReg, setPasswordReg] = useState("");
  const [emailReg, setEmailReg] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phonenumReg, setPhoneNumReg] = useState("");
  const [bldgrp, setBldGrp] = useState("");
  const [dob, setDob] = useState(new Date());
  const [selectedGender, setSelectedGender] = useState("");
  const [message, setMessage] = useState("");

  const [reg_otp, setOtp] = useState("");
  //const [isCorrectAge, setIsCorrectAge] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleGenderChange = (event) => {
    setSelectedGender(event.target.value);
  };

  const registerUser = async () => {
    try {
      const response = await register(
        emailReg,
        passwordReg,
        firstName,
        lastName,
        phonenumReg,
        bldgrp,
        dob,
        selectedGender
      );
      toast.success("Registration Successful");
      setTimeout(() => {
        window.location.href = "/login";
      }, 1000);
    } catch (err) {
      toast.error("Registration Failed");
      console.log(err);
    }
  };

  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function registerClick() {
    if (
      emailReg === "" ||
      passwordReg === "" ||
      firstName === "" ||
      lastName === "" ||
      phonenumReg === "" ||
      bldgrp === "" ||
      dob === "" ||
      selectedGender === ""
    ) {
      setMessage("Please fill all the fields");
    } else {
      setIsLoading(true);
      registerUser();
      // sendOTP(emailReg)
      //   .then((response) => {
      //     if (response.status === 200) {
      //       toast.success("OTP Sent");
      //       setMessage("OTP Sent At Email");
      //       setIsOpen(true);
      //     }
      //   })
      //   .catch((error) => {
      //     if (error.response.status === 400) {
      //       setMessage("Account with this Email Already Exists");
      //     } else {
      //       toast.error("OTP Error");
      //       setMessage("Error In sending OTP at");
      //     }
      //   })
      //   .finally(() => {
      //     setIsLoading(false);
      //   });
    }
  }

  // function handleverifyOTP(otp) {
  //   verifyOTP(emailReg, otp)
  //     .then((response) => {
  //       toast.success("Success");
  //       registerUser();
  //       closeModal();
  //     })
  //     .catch((error) => {
  //       toast.error("Error");
  //       console.log(error);
  //     });
  // }

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  // Convert Date object to yyyy-MM-dd format for the input field
  const formattedDob = dob.toISOString().split("T")[0]; // This will give 'yyyy-MM-dd'

  return (
    <>
      <div className="flex flex-col items-center justify-center px-2 py-5 mx-auto font-pop">
        <div className="w-full rounded-lg shadow lg:w-3/4">
          <div className="space-y-4 p-4 lg:p-6 ">
            <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
              Sign Up
            </h1>
            <form
              onSubmit={handleSubmit}
              className="space-y-4 md:space-y-6"
              autoComplete="off"
            >
              <div>
                <input
                  type="email"
                  className="bg-gray-50 border-2 border-red-600 sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3"
                  required
                  id="EmailReg"
                  name="EmailReg"
                  placeholder="Email"
                  value={emailReg}
                  onChange={(e) => setEmailReg(e.target.value)}
                />
              </div>
              <div>
                <input
                  type="text"
                  className="bg-gray-50 border-2 border-red-600 sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3"
                  required
                  id="passwordReg"
                  name="passwordReg"
                  placeholder="Password..."
                  value={passwordReg}
                  onChange={(e) => setPasswordReg(e.target.value)}
                />
              </div>

              <hr className="h-px my-8 bg-gray-200 border-0"></hr>

              <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
                Medical Info
              </h1>

              <div>
                <input
                  type="text"
                  className="bg-gray-50 border-2 border-red-600 sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3"
                  required
                  id="firstNameReg"
                  name="FirstNameReg"
                  placeholder="First Name.."
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div>
                <input
                  type="text"
                  className="bg-gray-50 border-2 border-red-600 sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3"
                  required
                  id="lastNameReg"
                  name="LastNameReg"
                  placeholder="Last Name.."
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>

              <div>
                <input
                  type="text"
                  className="bg-gray-50 border-2 border-red-600 sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3"
                  required
                  id="phonenumReg"
                  name="phonenumReg"
                  placeholder="Phone Number"
                  value={phonenumReg}
                  onChange={(e) => setPhoneNumReg(e.target.value)}
                />
              </div>

              <div className="flex flex-row space-x-5 text-2xl py-8">
                <h3 className="font-bold">Sex:</h3>
                <label>
                  <input
                    type="radio"
                    value="Male"
                    className="mr-2 w-4 h-4"
                    checked={selectedGender === "Male"}
                    onChange={handleGenderChange}
                  />
                  Male
                </label>
                <label>
                  <input
                    type="radio"
                    value="Female"
                    className="mr-2 w-4 h-4"
                    checked={selectedGender === "Female"}
                    onChange={handleGenderChange}
                  />
                  Female
                </label>
                <label>
                  <input
                    type="radio"
                    value="Other"
                    className="mr-2 w-4 h-4"
                    checked={selectedGender === "Other"}
                    onChange={handleGenderChange}
                  />
                  Other
                </label>
              </div>
              <div>
                <label
                  htmlFor="blood-group"
                  className="block mb-3 items-start font-bold mt-2 text-2xl"
                >
                  Blood Group:
                </label>
                <FormControl fullWidth>
                  <Select
                    id="blood-group"
                    value={bldgrp}
                    variant="outlined"
                    label="blood-group"
                    sx={{
                      color: red,
                      border: "3px solid red",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "0px",
                      },
                    }}
                    onChange={(e) => setBldGrp(e.target.value)}
                  >
                    <MenuItem value={"A+"} sx={{ fontSize: 22 }}>
                      A+
                    </MenuItem>
                    <MenuItem value={"A-"} sx={{ fontSize: 22 }}>
                      A-
                    </MenuItem>
                    <MenuItem value={"B+"} sx={{ fontSize: 22 }}>
                      B+
                    </MenuItem>
                    <MenuItem value={"B-"} sx={{ fontSize: 22 }}>
                      B-
                    </MenuItem>
                    <MenuItem value={"O+"} sx={{ fontSize: 22 }}>
                      O+
                    </MenuItem>
                    <MenuItem value={"O-"} sx={{ fontSize: 22 }}>
                      O-
                    </MenuItem>
                    <MenuItem value={"AB+"} sx={{ fontSize: 22 }}>
                      AB+
                    </MenuItem>
                    <MenuItem value={"AB-"} sx={{ fontSize: 22 }}>
                      AB-
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div>
                <label
                  htmlFor="dob"
                  className="block mb-3 items-start font-bold mt-2 text-xl"
                >
                  Date Of Birth:
                </label>
                <div className="border-2 border-red-500 rounded-md p-2 w-fit">
                  <input
                    type="date"
                    value={formattedDob} // Use formatted date
                    onChange={(e) => setDob(new Date(e.target.value))}
                  />
                </div>
              </div>
              <div className="pt-8 flex items-center justify-center">
                <button
                  type="submit"
                  className="w-80 text-white bg-red-700 hover:bg-red-300 font-medium rounded-lg text-lg px-2.5 py-2.5 text-center"
                  onClick={registerClick}
                >
                  Register
                </button>
              </div>

              <p className="text-2xl font-semibold">{message}</p>
            </form>
          </div>
        </div>
      </div>

      {/**<Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => {}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex justify-between items-center">
                    <Dialog.Title
                      as="h3"
                      className="text-xl font-bold leading-6 text-gray-900 mb-2 font-pop"
                    >
                      OTP sent at <span className="underline">{emailReg}</span>
                    </Dialog.Title>
                 
                    <button
                      type="button"
                      className="text-gray-400 hover:text-gray-600 focus:outline-none"
                      onClick={closeModal}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>

                  <div>
                    <div>
                      <div className="mb-1 font-pop">
                        <input
                          className="input-red"
                          value={reg_otp}
                          placeholder="Enter OTP"
                          onChange={(e) => setOtp(e.target.value)}
                        ></input>
                      </div>
                    </div>
                    <div className="mt-4 flex justify-center">
                      <button
                        type="button"
                        className="font-pop inline-flex justify-center rounded-md border border-transparent bg-blue-700 px-4 py-2 text-md font-medium text-white hover:bg-blue-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        onClick={(e) => handleverifyOTP(reg_otp)}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>**/}
    </>
  );
};

export default Register;
